<template>
  <v-app v-bind:style="{ background: 'white', width: widthNow }">
    <TopToolbarDesktop
      v-if="widthNowVal(widthNow) >= 550"
      v-bind:style="{ background: 'white', width: widthNow }"
    ></TopToolbarDesktop>
    <TopToolbarMobile v-else />

    <!-- <PopUpLogin />
    <router-view />-->
    <v-content class="no-x-overflow">
      <router-view></router-view>
    </v-content>
    <BottomNavMobile v-if="widthNowVal(widthNow) <= 550" />
    <BottomNavDesktop v-else />
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld"
// import PopUpLogin from "./components/PopUpLogin";
// import instance from "./myconfig";

import TopToolbarDesktop from "./components/TopToolbar/TopToolbarDesktop.vue";
import TopToolbarMobile from "./components/TopToolbar/TopToolbarMobile.vue";
import BottomNavDesktop from "./components/BottomNavDesktop.vue";
import BottomNavMobile from "./components/BottomNavMobile.vue";
// import { Plugins } from "@capacitor/core";
// const { PushNotifications } = Plugins;
// import { FCM } from "capacitor-fcm";
// const fcm = new FCM();
// const { FCMPlugin } = Plugins;
export default {
  name: "App",

  components: {
    TopToolbarDesktop,
    TopToolbarMobile,
    BottomNavDesktop,
    BottomNavMobile,
  },
  created() {
    this.fetchMain();
    if (window.innerWidth >= 550) {
      window.addEventListener("resize", this.myEventHandler);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  computed: {
    masterData() {
      return this.$store.state.masterData;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      this.$store.commit("LOGOUT");
    },
    async fetchMain() {
      // await this.$store.dispatch("login");
      await this.$store.dispatch("getData");
    },
    myEventHandler() {
      // console.log(e);
      this.heightNow = window.innerHeight + "px";
      this.widthNow = window.innerWidth + "px";

      // your code for handling resize...
    },
    widthNowVal(width) {
      return Number(width.substring(0, width.length - 2));
    },
  },

  data: () => ({
    //
    heightNow: window.innerHeight + "px",
    widthNow: window.innerWidth + "px",
    snackbar: false,
    dialog: false,
    dialog2: false,
    test: "belum",
    dialog3: false,
  }),
};
</script>
<style scoped>
a.bar.router-link-exact-active {
  color: #f5ca4a;
  text-decoration: none;
}
a.bar {
  color: black;
  text-decoration: none;
}
.no-x-overflow {
  overflow: hidden;
}
</style>
